import React, {useState} from 'react';
import NavigationItem from './NavigationItem';
import {useSelector} from 'react-redux';
import {useIsMobileOrTablet} from "../Utility/TailWindBreakPoints";

const Navigation = () => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const [openId, setOpenId] = useState(null);
    
    const isMobileOrTablet = useIsMobileOrTablet();
    
    return ( <NavigationItem links={contentLinks} openId={openId} setOpenId={setOpenId} isMobileOrTablet={isMobileOrTablet} />);
};

export default Navigation;
